// extracted by mini-css-extract-plugin
module.exports = {"root":"ServicePortalSidebar_root__HMTy8","header":"ServicePortalSidebar_header__Hml4N","container":"ServicePortalSidebar_container__Kfyba"};